<template>
    <div class="hide-filters">
        <div v-if="!filtersHidden">
            <button @click="toggleFilters"><span class="icon-cancel"></span>{{ $t("General.hide_filters") }}</button>
        </div>
        <div v-if="filtersHidden">
            <button @click="toggleFilters"><span class="icon-filter"></span>{{ $t("General.show_filters") }}</button>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'HideFilters',
        props: {
            filtersHidden: Boolean
        },
        methods: {
            toggleFilters () {
                this.$emit('toggleFilters', this.filtersHidden)
            }
        }
    }

</script>

<style lang="scss" scoped>

    .hide-filters {
        display: flex;
        justify-content: flex-start;

        button {
            display: flex;
            flex-direction: row;
            border-radius: 20px;
            padding: 10px 25px 10px 15px;
            gap: 10px;
            border: 0;
            background-color: $alto;
            align-items: center;
            cursor: pointer;
        }
    }

</style>
